import React from "react";
import { Link } from "react-router-dom";
import HeaderLogo from '../../assets/logo.png';
import "./authentication.css"
export default function AuthenticationHeader() {

    return (
        <>
            <header>
                <div className='header_rooter'>
                    <div className='site_logo'>
                        <Link to="/home"><img src={HeaderLogo} alt="Logo" className="logo" /></Link>
                    </div>
                    <div className='header_buttons'>
                        <ul>
                            <li><Link to='/login'>LOGIN</Link></li>
                            <li><Link to='/register'>Register</Link></li>
                        </ul>
                    </div>
                </div>
            </header>
        </>
    )
}